import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import 'rxjs/add/operator/map';
import { environment } from './../../environments/environment';
import { Observable } from 'rxjs/Observable'
import { Company } from '../../models/company';
import { UniverseCompany } from '../../models/universe-company.model';
import { User } from '../../models/user';
import { CompanyAnalysis } from '../../models/company-analysis.model';

import * as fromRoot from '../../reducers'
import { Store } from '@ngrx/store';
import { Contact } from '../../models/contact.model';

export interface GetCompanyResult {
  success: boolean;
  data: Company
}

@Injectable()
export class Api {
  user: any;
  public baseUrl: string = environment.BASE_URL;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'x-api-key': environment.API_KEY
  });

  constructor(public store: Store<fromRoot.State>, public http: HttpClient, public authHttp: HttpClient) {
    let u = this.store.select(fromRoot.getUser);
    u.subscribe(res => this.user = res);
  }

  fetchPlatformInfo() {
    return this.authHttp.get(`${this.baseUrl}/companies/platforminfo`, { headers: this.headers })
      .map(r => r as any)
      .map((t: any) => t);
  }

  setFilter(filter) {
    // Slice the filter into the current user filters
    let filters = [...this.user.filters];
    filters = filters.filter(f => f.id !== filter.id)
    filters.push(filter);

    return this.authHttp.put(`${this.baseUrl}/users/${this.user._id}`, { filters: filters }, { headers: this.headers })
      .map(r => r as User[])
      .map((t: any) => t);
  }

  resetFilters(user) {
    return this.authHttp.get(`${this.baseUrl}/users/${user._id}/resetfilters`, { headers: this.headers })
      .map(r => r as User[])
      .map((t: any) => t);
  }

  fetchUser(id: string): Observable<User> {
    return this.authHttp.get(`${this.baseUrl}/users/${id}`, { headers: this.headers })
      .map(r => r as User)
      .map((t: User) => t)
  }

  updateUser(upd) {
    return this.authHttp.put(`${this.baseUrl}/users/${upd._id}`, upd, { headers: this.headers })
      .map(r => r as User[])
      .map((t: any) => t);
  }

  updateCompany(company) {
    return this.authHttp.put(`${this.baseUrl}/companies/${company.ticker}`, company, { headers: this.headers })
      .map(r => r as any)
      .map((t: any) => t);
  }

  deleteCompany(id) {
    return this.authHttp.delete(`${this.baseUrl}/companies/${id}`, { headers: this.headers })
  }

  getCompanyByTicker(ticker: string): Observable<Company> {
    console.log("banana getCompanyByTicker 1", { url: `${this.baseUrl}/companies/${ticker}` });
    return this.authHttp.get(`${this.baseUrl}/companies/${ticker}`, { headers: this.headers })
      .map(r => {
        console.log("banana getCompanyByTicker 2", { r });
        return r as Company
      })
      .map((t: Company) => t)
  }

  getCompaniesByFuzzySearch(searchTerm: string): Observable<Company> {
    return this.authHttp.get(`${this.baseUrl}/companies/fuzzy/${searchTerm}`, { headers: this.headers })
      .map(r => r as Company[])
      .map((t: any) => t);
  }

  getCompanyAnalysis(body = {}): Observable<any> {
    return this.authHttp.post(`${this.baseUrl}/companies/analysis`, body, { headers: this.headers })
      .map(results => results as CompanyAnalysis[])
      .map((t: any) => t);
  }

  getCompaniesErrors(body = {}): Observable<any> {
    return this.authHttp.post(`${this.baseUrl}/companies/errors`, body, { headers: this.headers })
      .map(results => results as any[])
      .map((t: any) => t);
  }

  getCompanyComparisonData(ticker: string): Observable<Company> {
    return this.authHttp.get(`${this.baseUrl}/companies/${ticker}/basic`, { headers: this.headers })
      .map(r => r as Company)
      .map((t: Company) => t)
  }


  getCompaniesBySector(sector: string) {
    return this.getCompanies({
      sector
    })
  }

  getCompaniesByRegion(region: string) {
    return this.getCompanies({
      region
    })
  }

  getCompaniesBySectorIndustry(sector: string, industry: string) {
    return this.getCompanies({
      sector,
      industry
    })
  }

  getCompanies(filters = {}) {
    return this.authHttp.get(`${this.baseUrl}/companies`, { params: filters, 'headers': this.headers })
      .map(r => r as Company[])
      .map((t: any) => t);
  }

  getCompaniesByTickers(tickers) {
    return this.authHttp.get(`${this.baseUrl}/companies`, { headers: this.headers })
      .map(r => r as Company[])
      .map((t: any) => t);
  }


  /**
   * User
   */

  saveFlex(ticker, user_id, flex): Observable<User> {
    return this.authHttp.put(`${this.baseUrl}/users/${user_id}`, { flex, ticker }, { headers: this.headers })
      .map(r => r as User[])
      .map((t: any) => t);
  }

  fetchSectors(): Observable<any> {
    return this.authHttp.get(`${this.baseUrl}/companies/sectors`, { headers: this.headers })
      .map(r => r as any[])
      .map((t: any) => t);
  }

  fetchRegions(): Observable<any> {
    return this.authHttp.get(`${this.baseUrl}/companies/regions`, { headers: this.headers })
      .map(r => r as any[])
      .map((t: any) => t);
  }

  fetchFilters(user_id: string): Observable<any> {
    return this.authHttp.get(`${this.baseUrl}/users/${user_id}/filters`, { headers: this.headers })
      .map(r => r as any[])
      .map((t: any) => t);
  }

  createFilter(filter: any): Observable<any> {
    // Dont need the user ID
    delete (filter.id);
    return this.authHttp.post(`${this.baseUrl}/users/${this.user._id}/filters`, filter, { headers: this.headers })
      .map(r => r as any[])
      .map((t: any) => t);
  }

  renameFilter(user_id: string, filter: any): Observable<any> {
    return this.authHttp.put(`${this.baseUrl}/users/${user_id}/filters/${filter.ref}`, { filter }, { headers: this.headers })
      .map(r => r as any[])
      .map((t: any) => t);
  }

  updateFilter(user_id: string, filter: any): Observable<any> {
    return this.authHttp.put(`${this.baseUrl}/users/${user_id}/filters/${filter.ref}`, { filter }, { headers: this.headers })
      .map(r => r as any[])
      .map((t: any) => t);
  }

  addStockToFilter(user, filter, company) {
    return this.authHttp.post(`${this.baseUrl}/users/${user._id}/filters/${filter.ref}/tickers`, { ticker: company.ticker }, { headers: this.headers })
      .map(r => r as any[])
      .map((t: any) => t);
  }

  deleteFilter(user_id: string, filter: any): Observable<any> {
    return this.authHttp.delete(`${this.baseUrl}/users/${user_id}/filters/${filter.ref}`, { headers: this.headers })
      .map(r => r as any[])
      .map((t: any) => t);
  }

  fetchUsers() {
    return this.authHttp.get(`${this.baseUrl}/users`, { headers: this.headers })
      .map(r => r as any)
      .map((t: any) => t);
  }

  addUser(user) {
    return this.authHttp.post(`${this.baseUrl}/users`, user, { headers: this.headers })
      .map(r => r as any[])
      .map((t: any) => t);
  }

  deleteUser(user) {
    return this.authHttp.delete(`${this.baseUrl}/users/${user._id}`, { headers: this.headers })
      .map(r => r as any[])
      .map((t: any) => t);
  }

  getUniverseCompanies() {
    return this.authHttp.get(`${this.baseUrl}/universe`, { headers: this.headers })
      .map(r => r as UniverseCompany[])
      .map((t: any) => t);
  }

  getUniverseCompany(perm_sec_id: string): Observable<Company> {
    console.log("banana getUniverseCompany");
    return this.authHttp.get(`${this.baseUrl}/universe/${perm_sec_id}`, { headers: this.headers })
      .map(r => r as Company)
      .map((t: Company) => t)
  }

  addUniverseCompany(payload) {
    return this.authHttp.post(`${this.baseUrl}/universe`, payload, { headers: this.headers })
      .map(r => r as any)
      .map((t: any) => t);
  }

  updateUniverseCompany(payload) {
    return this.authHttp.put(`${this.baseUrl}/universe/${payload.perm_sec_id}`, payload, { headers: this.headers })
      .map(r => r as any)
      .map((t: any) => t);
  }

  updateUniverseCompanyAdjustment(perm_sec_id, adjustment) {
    return this.authHttp.put(`${this.baseUrl}/universe/${perm_sec_id}/adjustment/${adjustment.id}`, adjustment, { headers: this.headers })
      .map(r => r as any)
      .map((t: any) => t);
  }

  deleteUniverseCompany(perm_sec_id) {
    return this.authHttp.delete(`${this.baseUrl}/universe/${perm_sec_id}`, { headers: this.headers, responseType: 'text' });
  }

  addUniverseCompanyAdjustment(perm_sec_id, adjustment) {
    return this.authHttp.post(`${this.baseUrl}/universe/${perm_sec_id}/adjustment`, adjustment, { headers: this.headers })
      .map(r => r as any)
      .map((t: any) => t);
  }

  deleteUniverseCompanyAdjustment(perm_sec_id, adjustment) {
    return this.authHttp.delete(`${this.baseUrl}/universe/${perm_sec_id}/adjustment/${adjustment.id}`, { headers: this.headers })
      .map((t: any) => t);
  }

  getAllAdjustments() {
    return this.authHttp.get(`${this.baseUrl}/universe/adjustments`, { headers: this.headers })
      .map(r => r as any[])
      .map((t: any) => t);
  }

  sendContactMessage(contact: Contact): Observable<any> {
    return this.authHttp.post(`${this.baseUrl}/auth/contact`, contact, { headers: this.headers })
      .map(r => r as any)
      .map((t: any) => t);
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts